<script setup>
import { Modal } from "bootstrap";
import { onMounted, watch, ref } from "vue";
import useEventListener from "../../hooks/useEventListener";

const emits = defineEmits(["update:modelValue", "ok", "cancel", "show", "hide"]);
const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	btnSecondary: {
		type: String,
		default: null,
	},
	btnPrimary: {
		type: String,
		default: null,
	},
	modalClass: {
		type: String,
		default: "",
	},
	isRefund: {
		type: Boolean,
		default: false,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	isRefundAvailableError: {
		type: Boolean,
		default: false,
	}

});

const myModalEl = ref(null);
const instance = ref();

useEventListener(myModalEl, "hide.bs.modal", () => {
	emits("hide");
	emits("update:modelValue", false);
});

useEventListener(myModalEl, "show.bs.modal", () => {
	emits("show");
	emits("update:modelValue", true);
});

onMounted(() => {
	instance.value = new Modal(myModalEl.value);
	if (props.modelValue) instance.value?.show();
});

watch(
	() => props.modelValue,
	value => (value ? instance.value.show() : instance.value.hide())
);
</script>

<template>
	<div ref="myModalEl" class="modal fade" :class="modalClass">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content" :class="{'modal-content_refund': isRefund}">
				<div class="modal-header" :class="{'modal-header_refund': isRefund}">
					<button
						type="button"
						class="btn-close"
						:class="{'btn-close_refund': isRefund}"
						data-bs-dismiss="modal"
						data-test-id="modal_close_btn"
						aria-label="Close"
					></button>
					<div v-if="$slots.header" class="modal-title"><slot name="header"></slot></div>
				</div>
				<div v-if="$slots.body"
					class="modal-body" 
					:class="{'modal-body_refund': isRefund}">
					<slot name="body"></slot>
				</div>
				<div v-if="btnSecondary || btnPrimary" 
					class="modal-footer" 
					:class="{'modal-footer_refund': isRefund}">
					<button
						v-if="btnSecondary"
						type="button"
						class="btn btn-secondary"
						data-bs-dismiss="modal"
						@click="$emit('cancel')"
					>
						{{ btnSecondary }}
					</button>
					<button
						v-if="btnPrimary"
						type="button"
						class="btn btn-primary"
						:class="{'btn_wide btn_refund': isRefund}"

						data-bs-dismiss="modal"
						data-test-id="modal_submit_btn"
						@click="$emit('submit')"
						:disabled="isDisabled"

					>
						{{ btnPrimary }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-modal.scss";
@import "frontend/web/src/styles/custom/btn.scss";

.btn-close {
	
	&_refund {
		opacity: 1;
		
		&:hover {
			opacity: 1;
		}
	}
}

</style>

